import {BaseRemoteConfigModel} from "../../../infrastructure/models/base-remote-config.model";
import type {LocalStorageUtils} from "../../../infrastructure/utils/local-storage.utils";
import {LOCAL_STORAGE_KEYS} from "../../consts";

export class PopupDisplayRemoteConfigModel extends BaseRemoteConfigModel {
  name: String;
  firstSessionToDisplay: Number;
  displayPageInFirstSession: Number;
  maximumDisplays: Number;
  nextDisplayVisits: Number;
  prioritization: Number;
  delay: Number;
  version: Number;

  nextDisplaySession: Number;

  constructor(model: PopupDisplayRemoteConfigModel, popupDisplayCounterDictionary: Map<String, Number>, localStorageUtils: LocalStorageUtils) {
    super(model);

    this.name = model.name;
    this.firstSessionToDisplay = model.firstSessionToDisplay;
    this.displayPageInFirstSession = model.displayPageInFirstSession;
    this.maximumDisplays = model.maximumDisplays;
    this.nextDisplayVisits = model.nextDisplayVisits;
    this.prioritization = model.prioritization;
    this.delay = model.delay;
    this.version = model.version;

    this.popupDisplayCounterDictionary = popupDisplayCounterDictionary || {};
    this.localStorageUtils = localStorageUtils;

    this.nextDisplaySession = model.firstSessionToDisplay;
    this.initVisibleCounter();

  }

  initVisibleCounter() {
    const isVersionUpdated = this.popupDisplayCounterDictionary[this.name]?.version > 0 &&  this.version > 0 && this.popupDisplayCounterDictionary[this.name]?.version < this.version;
    const shouldResetData = (this.popupDisplayCounterDictionary[this.name] === undefined) || isVersionUpdated;
    const sessionCounter = this.localStorageUtils.get(LOCAL_STORAGE_KEYS.popupSessionCounter);

    if (shouldResetData) {
      this.visibleCounter = 0;
      this.nextDisplaySession = this.firstSessionToDisplay + sessionCounter;
      this.popupDisplayCounterDictionary[this.name] = {
        visibleCounter: this.visibleCounter,
        nextDisplaySession: this.nextDisplaySession,
        version: this.version
      };
    } else {
      if(!(this.popupDisplayCounterDictionary[this.name].version > 0)) {
        this.popupDisplayCounterDictionary[this.name].version = this.version;
      }

      this.visibleCounter = this.popupDisplayCounterDictionary[this.name].visibleCounter;
      this.nextDisplaySession = this.popupDisplayCounterDictionary[this.name].nextDisplaySession;
    }

    this.localStorageUtils.set(LOCAL_STORAGE_KEYS.popupAutoDisplayCounters, this.popupDisplayCounterDictionary);
  }

  get pageToDisplay(): Number {
    return this.visibleCounter === 0 ? this.displayPageInFirstSession : 0;
  }
}
